import Mahakam1 from '../../Media/Residential/Mahakam.webp'
import Mahakam2 from '../../Media/Residential/Mahakam.webp'


const Mahakamimages =[
Mahakam1,Mahakam2
]

export default Mahakamimages;